import { useMsal } from '@azure/msal-react';
import { tokenStorage } from '@/services/tokenStorage';
import { useCallback } from 'react';
import { clearSelectedOrganisation } from '@/utils/storage';
import { PUBLIC_ROUTES } from '@/configs/routes';

export function useLogout() {
  const { instance } = useMsal();

  const logout = useCallback(async () => {
    try {
      console.log('[Auth] Logging out, clearing stored tokens...');

      // Clear stored tokens
      tokenStorage.clearTokens();

      // Clear any non auth-related storage
      clearSelectedOrganisation();
      sessionStorage.clear();

      // Perform MSAL logout
      await instance.logoutRedirect({
        postLogoutRedirectUri: PUBLIC_ROUTES.HOME,
      });
    } catch (error) {
      console.error('[Auth] Logout error:', error);
      // Force redirect even if MSAL logout fails
      window.location.href = PUBLIC_ROUTES.HOME;
    }
  }, [instance]);

  return { logout };
}
